import { CreateRepuestosDTO } from "@/application/dto/repuesto/CreateRepuestosDTO";
import { IRepuestoRepository } from "@/domain/repositories/IRepuestoRepository";

// application/use-cases/CreateRepuestoUseCase.ts

export class PostRepuestoUseCase {

    constructor(
        private repository: IRepuestoRepository
    ) {}

    async execute(data: CreateRepuestosDTO) {
        
        return this.repository.create(data);
    }

}
